import React from "react";

import { withRouter } from "react-router";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";

import { addNewID } from "core-module/services/ids/actions";
import store from "store";
import config from "config";
import loadForm from "core-module/hoc/loadForm";
import * as api from "core-module/services/api";
import EasyOpenInput from "common/components/EasyForm/EasyOpenInput";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import Button from "common/components/CustomButtons/Button.jsx";
// @material-ui/core components
import ErrorIcon from "@material-ui/icons/Error";

import loadContent from "core-module/hoc/loadContent";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardIconTitle: importedStyle.cardIconTitle,
  cardCategory: importedStyle.cardCategory,
  cardTitle: {
    ...importedStyle.cardTitle,

    marginTop: "30px",
    marginBottom: "30px",
    marginLeft: "30px",
  },
  stats: importedStyle.stats,
  button: {
    fontWeight: "bold",
  },
};

const ClearableRaw = (props) => {
  const postClear = async () => {
    const signature = props.connectForm.getValue("signature");

    await api.post("user." + props.ids.user + "/cleardisruptiveticket", {
      signature,
    });

    store.dispatch(addNewID("user", ""));
    store.dispatch(addNewID("user", props.ids.user));
  };

  return (
    <GridContainer justify="center" align="center">
      <GridItem xs={6}>
        <EasyOpenInput propName="signature" connectForm={props.connectForm} />
        <Button onClick={postClear} color="primary">
          Clear Message
        </Button>
      </GridItem>
    </GridContainer>
  );
};

const Clearable = loadForm("user.props/cleardisruptiveticket.0", ClearableRaw);

const ManualRegisterButtonRaw = (props) => {
  const { classes } = props;
  const isAtHome = props.getData("private", "value");

  return (
    <div>
      <Button
        onClick={() => {
          window.open("http://mcsnet.ca", "_self");
        }}
        disabled={!isAtHome}
        color={isAtHome ? "primary" : "default"}
        className={classes.button}
      >
        Automatic Register
      </Button>
      <br />
      {isAtHome ? null : (
        <small key="notathome">
          (You need to be at home in order to do an automatic register)
        </small>
      )}
    </div>
  );
};

const ManualRegisterButton = withStyles(styles)(
  loadContent("me.1/whatismyipaddress", ManualRegisterButtonRaw)
);

const Messages = (props) => {
  const { classes } = props;
  const storeState = store.getState();
  return (
    <div>
      {props.getList((oGet, id) => {
        if (oGet("type") === "disruptiveticket") {
          return (
            <Card key={id}>
              <CardHeader color="danger" icon>
                <CardIcon color="danger">
                  <ErrorIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{oGet("title")}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer align="flex-start">
                  <GridItem xs={12}>
                    <h4 className={classes.cardTitle}>{oGet("body")}</h4>
                  </GridItem>

                  {oGet("clearable", "value") ? (
                    <GridItem xs={12}>
                      <h4 key="clearable" className={classes.cardTitle}>
                        To clear message(s) and re-enable your service, if you
                        are the account owner please provide your name in the
                        box below (Eg. "Joe Smith"). If you aren't the account
                        owner, please provide your name as well as the account
                        holders name in the box below (Eg. "John Doe for Joe
                        Smith"). Once completed click the 'Clear Message(s)'
                        button
                      </h4>
                      <Clearable pathids={{ user: oGet("user") }} />
                    </GridItem>
                  ) : (
                    <GridItem xs={12}>
                      <h4 key="notclearable" className={classes.cardTitle}>
                        Still Need Help? Contact Us!
                        <br />
                        Our team is here to assist you 7 days a week, including
                        holidays.
                        <br />
                        Local Phone: 780-645-4417 ext. 1
                        <br />
                        Toll-Free: 1-866-390-3928 ext. 1
                        <br />
                        Email: customerservice@mcsnet.ca
                        <br />
                        We aim to respond to all email inquiries within one
                        business day.
                        <br />
                        Address: 4810 50th Ave, PO Box 98, St Paul, AB T0A3A0
                      </h4>
                    </GridItem>
                  )}
                </GridContainer>
              </CardBody>
            </Card>
          );
        } else if (oGet("type") === "hitcap") {
          return (
            <Card key={id}>
              <CardHeader color="danger" icon>
                <CardIcon color="danger">
                  <ErrorIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{oGet("title")}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer align="flex-start">
                  <GridItem xs={12}>
                    <h4 className={classes.cardTitle}>
                      <b>
                        You've reached your monthly traffic CAP (gigabytes). At
                        this point, you have two options:{" "}
                      </b>
                      <br />
                      <br />
                      You can enable Unlimited Mode, this will allow you to
                      continue to use the Internet until the end of the month,
                      but at a much slower speed. This mode is free to use and
                      your connection will return to 'Turbo Mode' on the first
                      of the next month when the usage cap resets:
                    </h4>
                    <br />
                  </GridItem>
                  <GridItem xs={12} align="center">
                    <Button
                      onClick={() => {
                        if (storeState.services.ids.user === oGet("user")) {
                          props.history.push(
                            config.MYACCOUNT.APP_PATH + "/user/package",
                            {
                              action: "unlimited",
                            }
                          );
                        } else {
                          store.dispatch(addNewID("user", oGet("user")));
                          props.history.push(
                            config.MYACCOUNT.APP_PATH + "/user/change",
                            {
                              action: "unlimited",
                            }
                          );
                        }
                      }}
                      color="default"
                    >
                      Enter unlimited mode
                    </Button>
                  </GridItem>
                  <GridItem xs={12}>
                    <h5 className={classes.cardTitle}>
                      <b>or</b>
                    </h5>
                  </GridItem>
                  <GridItem xs={12}>
                    <h5 className={classes.cardTitle}>
                      You can upgrade your package to get a significantly larger
                      traffic CAP (gigabytes) and higher speeds now and in the
                      future. As a bonus, by upgrading now, you will get to use
                      up to the <b>entire </b>
                      traffic CAP of the new package but you will only be
                      charged the remaining portion for the current month.{" "}
                    </h5>
                    <br />
                  </GridItem>
                  <GridItem xs={12} align="center">
                    <Button
                      onClick={() => {
                        if (storeState.services.ids.user === oGet("user")) {
                          props.history.push(
                            config.MYACCOUNT.APP_PATH + "/user/package",
                            {
                              action: "upgrade",
                            }
                          );
                        } else {
                          store.dispatch(addNewID("user", oGet("user")));
                          props.history.push(
                            config.MYACCOUNT.APP_PATH + "/user/change",
                            {
                              action: "upgrade",
                            }
                          );
                        }
                      }}
                      color="primary"
                      className={classes.button}
                    >
                      Upgrade package
                    </Button>
                  </GridItem>
                  <GridItem xs={12}>
                    <br />
                    <br />
                    <br />
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          );
        } else if (oGet("type") === "notregistered") {
          return (
            <Card key={id}>
              <CardHeader color="danger" icon>
                <CardIcon color="danger">
                  <ErrorIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{oGet("title")}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer align="flex-start">
                  <GridItem xs={12}>
                    <h4 className={classes.cardTitle}>
                      <b>
                        In order to have Internet access, you need to register
                        your connection
                      </b>
                      <br />
                    </h4>
                  </GridItem>
                  {oGet("multipleusers", "value") === false ? (
                    <GridItem xs={12} key="onlyoneuser">
                      <GridContainer align="flex-start">
                        <GridItem xs={12}>
                          <h4 className={classes.cardTitle}>
                            If your are at home (the service location), we can
                            do it automatically for you
                          </h4>
                          <br />
                        </GridItem>
                        <GridItem xs={12} align="center">
                          <ManualRegisterButton />
                        </GridItem>
                        <GridItem xs={12}>
                          <h5 className={classes.cardTitle}>
                            <b>or</b>
                          </h5>
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  ) : null}
                  <GridItem xs={12}>
                    <h5 className={classes.cardTitle}>
                      You can manually register your IP address with your
                      private router MAC address
                    </h5>
                    <br />
                  </GridItem>
                  <GridItem xs={12} align="center">
                    <Button
                      onClick={() => {
                        if (storeState.services.ids.user === oGet("user")) {
                          props.history.push(
                            config.MYACCOUNT.APP_PATH + "/user/advancedsettings"
                          );
                        } else {
                          store.dispatch(addNewID("user", oGet("user")));
                          props.history.push(
                            config.MYACCOUNT.APP_PATH + "/user/change",
                            {
                              action: "advancedsettings",
                            }
                          );
                        }
                      }}
                      color="primary"
                      className={classes.button}
                    >
                      Manual Register
                    </Button>
                  </GridItem>
                  <GridItem xs={12}>
                    <br />
                    <br />
                    <br />
                  </GridItem>
                  <GridItem xs={12}>
                    <h4 className={classes.cardTitle}>
                      <b>
                        If you have any problem please don't hesitate to contact
                        MCSnet. Our team is here to assist you 7 days a week,
                        including holidays. <br />
                        Local Phone: 780-645-4417 ext. 1
                        <br />
                        Toll-Free: 1-866-390-3928 ext. 1
                        <br />
                        Email: customerservice@mcsnet.ca
                        <br />
                        We aim to respond to all email inquiries within one
                        business day.
                        <br />
                        Address: 4810 50th Ave, PO Box 98, St Paul, AB T0A3A0
                      </b>
                    </h4>
                    <br />
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          );
        }
      })}
    </div>
  );
};

export default withStyles(styles)(
  withRouter(loadContent("me.1/accountwarning", Messages))
);
